import { useCallback } from "react";

function usePocketflowsTracking() {
  const identifyUser = useCallback(
    (operatorId: string, email: string) => {
      try {
        if (!(window as any).PocketflowsAnalytics) {
          return;
        }

        const customerExternalId = `${operatorId}_${email.toLowerCase().trim()}`;
        console.log("[Pocketflows] Identifying user:", customerExternalId);
        (window as any).PocketflowsAnalytics.track("identify", {
          customer_external_id: customerExternalId,
        });
      } catch (error) {
        console.error("[Pocketflows] Error during tracking:", error);
      }
    },
    []
  );

  return { identifyUser };
}

export { usePocketflowsTracking };
